import "common/polyfills";

import App from "./App";
import render from "../common/utils/render";
import { INITIAL_CLIENT_DATA } from "./common/utils";

const data = INITIAL_CLIENT_DATA;

render(App, {
  hasSessionRecording: data.integration_settings.analytics__client__has_session_recording,
  hasOnErrorRecording: data.integration_settings.analytics__client__has_on_error_recording,
});
